export default "__VITE_ASSET__gio_s5bK__"